var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPptLogoSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.536,0.425 L0.536,18.545 L34.736,18.545 L34.736,18.536 L34.736,7.5 C20.469,6.637 16.335,3.531 11.73,2.363 L11.73,2.363 C8.889,1.642 4.837,0.399 1.366,0.399 L1.366,0.399 C1.085,0.399 0.808,0.408 0.536,0.425",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "142.873338%",
    y1: "45.749013%",
    x2: "142.385101%",
    y2: "71.3474022%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "0.536 0.772167163 34.736 0.772167163 34.736 9.545 0.536 9.545"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-6",
    points: "0.536 0.7447 34.736 0.7447 34.736 9.23721044 0.536 9.23721044"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-8",
    points: "0.536 0.406289367 34.736 0.406289367 34.736 10.3267454 0.536 10.3267454"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(1.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.536,0.425 L0.536,18.545 L34.736,18.545 L34.736,18.536 L34.736,7.5 C20.469,6.637 16.335,3.531 11.73,2.363 L11.73,2.363 C8.889,1.642 4.837,0.399 1.366,0.399 L1.366,0.399 C1.085,0.399 0.808,0.408 0.536,0.425",
    id: "Fill-13",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(1.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4427,7.3804 C102.4427,7.3804 101.3337,7.8464 99.4637,7.6714 C96.3727,7.3844 91.2037,6.3174 85.5467,5.6354 C80.9307,5.0784 75.6397,3.3114 70.7827,3.0894 C65.2707,2.8374 58.3747,4.4994 53.8557,6.0174 C37.5227,11.5024 30.5007,-2.0006 16.1807,7.0354 C14.1357,8.3254 11.8977,8.9684 10.3257,9.1984 C7.5567,9.6054 5.5607,7.7444 3.8987,6.2084 C-0.2833,2.3434 -1.3273,-2.8776 -0.7293,4.4764 L-0.7293,13.4034 L102.3897,13.4034 L102.4427,7.3804 Z",
    id: "Fill-16",
    fill: "#FFFFFE",
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.263025,9.1977 C101.233,9.6067 84.407,6.6917 58.998,7.2927 C52.745,7.8837 46.2,10.1557 40.16,7.7617 C34.245,5.9717 28.941,2.2527 23.144,2.3397 C17.268,2.1577 13.456,6.5987 9.004,6.8877 C4.512,7.5537 1.186,4.8517 -0.46,3.1677 C-0.45,3.1677 -0.822,2.7517 -1.217,2.1957 L-1.828,1.3507 L-1.809,1.3367 C-1.618,0.7687 -1.403,0.7567 -1.235,0.7447 C-0.292,1.0777 -0.977,0.9627 -0.795,1.0917 C-0.807,1.6847 -0.859,2.1157 -0.987,2.0197 C-0.893,2.4537 -1.851,0.0847 -1.01,1.0737 C3.632,5.3017 2.186,3.8877 4.704,5.5207 C7.483,6.2887 6.946,6.5597 11.569,5.3787 C13.819,4.4437 13.455,4.5917 14.879,4.0677 C16.174,4.0657 19.717,-0.0243 30.033,3.2097 C48.78,12.7767 56.116,4.5497 65.23,6.3387 C74.33,5.8017 101.293,8.8827 101.263025,9.1977",
    id: "Fill-19",
    fill: "#FFFFFE",
    mask: "url(#mask-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.696,3.3306 C-2.696,3.3306 -2.684,3.1326 -2.656,2.7626 C-2.572,2.3576 -2.777,2.8426 -2.445,1.5906 C-1.975,1.0136 -2.215,0.3396 -0.41,0.4116 C1.469,1.3196 0.573,1.2316 0.938,1.4476 C1.604,2.7356 2.038,4.0576 3.032,5.7046 C4.445,9.1706 9.932,12.3796 15.321,8.6776 C25.848,0.9956 38.664,9.6596 45.168,8.7456 C51.689,8.5936 54.582,6.7936 56.384,6.3366 C58.19,5.7616 58.757,5.6236 59.742,5.5226 C61.741,5.2506 62.247,7.0566 65.968,5.1656 C69.81,3.4326 69.908,4.6926 74.466,4.8496 C79.048,5.1856 74.053,6.7266 84.787,6.8846 C95.564,7.4586 93.391,8.7676 97.951,9.0516 C99.092,9.1446 100.282,9.3256 101.263,9.4966 L101.954,9.6206 L102.033,9.6356 L102.072,9.6436 L102.091,9.6466 L102.1,9.6476 L102.105,9.6486 L102.108,9.6496 C102.055,10.2796 102.579,4.1636 102.356,6.7526 L102.199,6.7686 L101.905,6.7966 C101.533,6.8336 101.244,6.8646 101.072,6.8946 C100.726,6.9556 100.842,7.0106 101.685,7.0816 L102.034,7.1096 L102.237,7.1246 L102.344,7.1326 L102.372,7.1346 L102.379,7.1346 C102.012,11.4166 102.276,8.3206 102.193,9.2756 L102.19,9.2746 L102.177,9.2696 L102.125,9.2516 C101.849,9.1476 101.512,9.0326 101.13,8.8996 C100.361,8.6406 99.385,8.3166 98.164,7.9416 C88.344,5.0666 91.31,7.2106 87.443,6.6406 C83.543,6.1846 86.776,6.8826 79.693,5.2876 C72.756,3.8406 63.157,2.4006 53.643,6.8666 C51.331,7.8276 46.299,8.6626 40.473,7.2486 C34.757,6.1016 27.868,3.1456 21.065,5.3586 C17.732,6.3106 14.981,8.6666 12.189,9.5706 C9.338,10.5556 6.572,9.7776 4.959,8.0616 C3.269,6.4366 2.319,4.5306 1.63,3.0546 L1.144,1.9776 L0.832,1.3846 C0.684,1.2006 0.932,1.3846 0.462,0.9066 C-0.078,0.2926 -1.449,0.3826 -1.675,0.6456 C-2.995,2.1596 -2.451,2.6536 -2.615,2.7176 C-2.644,2.9706 -2.671,3.1766 -2.696,3.3306",
    id: "Fill-22",
    fill: "#004B6C",
    mask: "url(#mask-9)"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-26",
    stroke: "#004B6C",
    points: "1.136 36.045 36.136 36.045 36.136 1.045 1.136 1.045"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptLogoSm);
export default __webpack_public_path__ + "static/media/ppt_logo_sm.a114f3c4.svg";
export { ForwardRef as ReactComponent };